/* menu panel of the CE header on pages that do not load ce-suri.js */
(function () {
  var menu = document.querySelector('[data-menu]'); if (!menu) return;
  var set = function (on) { menu.classList.toggle('is-open', on); document.documentElement.style.overflow = on ? 'hidden' : ''; };
  document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
  document.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
})();
